export const STEPS = {
  upload: 1,
  mapping: 2,
  confirmation: 3,
  error: 4,
  success: 5,
};
